import clsx from "clsx";
import HorizontalRule from "../../../Rule/Horizontal";

export type AuthHeaderProps = {
  children?: React.ReactNode;
  className?: string;
  ruleClassName?: string;
};

export const AuthHeader = ({
  className,
  children,
  ruleClassName,
}: AuthHeaderProps) => {
  return (
    <>
      <div className={clsx(["pt-5 pb-[33px] text-3xl font-light", className])}>
        {children}
      </div>
      <HorizontalRule
        margin="0"
        className={clsx(["bg-black", ruleClassName])}
      />
    </>
  );
};
